import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';

import ShopView from './Shop.vue';
import PagesView from './views/Pages.vue';
import ClosedView from './views/Closed.vue';
import ErrorView from '@/pages/Error.vue';
import WaitingListView from '@/pages/shop/views/WaitingList.vue';
import { WAITING_LIST_ROUTE_NAME } from '@/utils/waitingList';
import DeferredPlaceOrder from '@/components/DeferredPlaceOrder.vue';
import { NavigationGuardNext } from 'vue-router/types/router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: {
            name: 'error',
        },
    },
    {
        path: '/closed',
        name: 'closed',
        component: ClosedView,
    },
    {
        path: '/error',
        name: 'error',
        component: ErrorView,
    },
    {
        path: '/:shop_id/placing-order/:deferred_token/no-cart',
        name: 'deferred-place-order-no-cart',
        component: DeferredPlaceOrder,
    },
    {
        path: '/:shop_id',
        name: 'shop',
        component: ShopView,
        children: [
            {
                path: 'placing-order/:deferred_token',
                name: 'deferred-place-order',
                component: DeferredPlaceOrder,
                beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
                    if (from === VueRouter.START_LOCATION) {
                        next({
                            name: 'deferred-place-order-no-cart',
                            params: to.params,
                            query: to.query,
                        });
                        return;
                    }
                    next();
                },
            },
            {
                path: 'waitinglist',
                name: WAITING_LIST_ROUTE_NAME,
                component: WaitingListView,
            },
            {
                path: ':page?',
                name: 'step',
                component: PagesView,
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.name === from.name && to.params.page === from.params.page) {
            return savedPosition;
        }

        return { x: 0, y: 0 };
    },
});

export default router;
